import { Check, Star } from "lucide-react";
import { Card } from "@/components/ui/card";

const PLANS = [
  {
    title: "12-Hour Duty",
    pill: "Most Common",
    highlight: true,
    daily: "₹960",
    monthly: "₹21,600",
    breakdown: [
      { label: "Wages", value: "₹800" },
      { label: "PF + ESI Contribution", value: "₹160" },
    ],
    perks: [
      "2-Shift coverage (Day / Night)",
      "Statutory benefits included",
      "OT as per government norms",
    ],
  },
  {
    title: "8-Hour Duty",
    pill: "Standard",
    daily: "₹638",
    monthly: "₹14,418",
    breakdown: [
      { label: "Wages", value: "₹534" },
      { label: "PF + ESI Contribution", value: "₹104" },
    ],
    perks: [
      "3-Shift coverage (Morning / Afternoon / Night)",
      "Statutory benefits included",
      "OT eligibility",
    ],
  },
];

export default function CompensationCards() {
  return (
    <div
      className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8"
      data-testid="compensation-cards"
    >
      {PLANS.map((p, idx) => (
        <Card
          key={p.title}
          data-testid={`compensation-card-${idx}`}
          className={`relative p-6 sm:p-8 rounded-sm bg-white rk-lift ${
            p.highlight
              ? "border-2 border-[#1F6B5C]"
              : "border border-[#E2E8F0]"
          }`}
        >
          <div className="flex items-center justify-between">
            <h3 className="font-display text-2xl font-bold text-[#0F172A]">
              {p.title}
            </h3>
            <span
              className={`text-[10px] tracking-widest uppercase font-bold px-2 py-1 rounded-sm ${
                p.highlight
                  ? "bg-[#1F6B5C] text-white"
                  : "bg-[#1E3A8A]/10 text-[#1E3A8A]"
              }`}
            >
              {p.highlight && <Star className="inline h-3 w-3 mr-1 -mt-0.5" />}
              {p.pill}
            </span>
          </div>
          <div className="mt-6 flex items-end gap-2">
            <span className="font-display text-5xl font-extrabold text-[#0F172A]">
              {p.daily}
            </span>
            <span className="text-sm text-[#64748B] mb-1.5">/ day total</span>
          </div>
          <div className="mt-2 inline-block bg-[#1E3A8A]/5 text-[#1E3A8A] font-semibold text-sm px-3 py-1 rounded-sm">
            ≈ {p.monthly} / month estimate
          </div>

          <div className="mt-6 grid grid-cols-2 gap-3">
            {p.breakdown.map((b) => (
              <div
                key={b.label}
                className="p-3 bg-[#F8FAFC] rounded-sm border border-[#E2E8F0]"
              >
                <div className="text-xs text-[#64748B]">{b.label}</div>
                <div className="font-display font-bold text-lg text-[#0F172A]">
                  {b.value}
                </div>
              </div>
            ))}
          </div>

          <ul className="mt-6 space-y-2.5">
            {p.perks.map((perk) => (
              <li
                key={perk}
                className="flex items-start gap-2 text-sm text-[#0F172A]"
              >
                <Check className="h-4 w-4 text-[#1F6B5C] mt-0.5 shrink-0" />
                {perk}
              </li>
            ))}
          </ul>
        </Card>
      ))}
    </div>
  );
}
